import * as React from 'react';
import Helper from 'src/support/Helper';
import { useEffect } from 'react';
import { useQuoteDetailStore } from 'src/hooks/quote-detail';
import ProductLegends from 'src/pages/ProductListing/ProductLegends';
import noImage from 'src/assets/images/noimage.png'
import getSymbolFromCurrency from 'currency-symbol-map';
import { useCartStore } from 'src/hooks/cart';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useProductPricingStore } from 'src/hooks/productPricing';

const QuoteCheckoutMyCart = (props) => {
    const [{ cart_quote_active_session, get_current_quote_cart }, { }, { set_quote_list_for_checkout }] = useQuoteDetailStore(); // 15033_main_orig
    const [{ }, { get_quote_currency }, { },] = useCartStore();
    const quoteList = get_current_quote_cart();
    const quoteCurrency = get_quote_currency(quoteList);
    const [{ pricingList }, { }, { }] = useProductPricingStore();
    const pricing = pricingList;

    useEffect(() => {
        function fetchHere() {
            get_current_quote_cart()
            set_quote_list_for_checkout(quoteList);
            QuoteCartCheckoutEvent()
        }
        fetchHere();
    }, [cart_quote_active_session]);

    // Added by Ramya [Quote cart checkout]
    function QuoteCartCheckoutEvent(){
        let quoteListData =[];
        localStorage.setItem("adobeEventType","quoteCartCheckout");
        let prodDetails = [];
        Object.entries(quoteList).map((data,key)=>{
            prodDetails.push(data[1].product);
            quoteListData.push(data[1])
        })
        prodDetails.map((data,ind)=>{
            let copyObj = {...data};
            let inventoryVal = copyObj?.assets?.inventory;
            copyObj.qas = inventoryVal?.qas;
            copyObj.subtotal = (quoteListData[ind]?.subTotal_quantity_1);
            copyObj.unitPrice = quoteListData[ind]?.price_quantity_1;
            copyObj.Quantity = quoteListData[ind]?.quantity_0;
            copyObj.priceSource = getPricing(
              data.ERPMFRPartNumber || data.erpMfrPartNumber,
              data.ERPPartNumber,
              data.ERPPartNumberModified
            )[0]?.priceSource;
            copyObj.quoteID = quoteListData[ind]?.quoteNumber;
            copyObj.quoteType= "online";
            prodDetails[ind] = copyObj;
          })
        let cartDetails = {
            "cartType" : "checkout",
            "quoteID":quoteListData[0]?.quoteNumber,
            "quoteType":"online"
        }
        if(Object.keys(prodDetails).length){
            HelperAdobeEvent.trackingAdobeEvent({prodDetails,cartDetails});
        }
    }
  const getPricing = (
    ERPMFRPartNumber,
    ERPPartNumber,
    ERPPartNumberModified
  ) => {
    ERPPartNumber = ERPPartNumberModified ? "" : ERPPartNumber;
    if (pricingList[ERPMFRPartNumber + "-" + ERPPartNumber]) {
      return pricingList[ERPMFRPartNumber + "-" + ERPPartNumber];
    }
    return [];
  };

    return (
        <>
            <div className="accordion accordion-with-arrow mycart-accordion mb-3 mt-3" id="mycart-accordion">
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne"><button id="collapseTwo" className="accordion-button font-16" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        My Cart
                    </button></h2>
                    <div id="collapseOne" className='accordion-collapse collapse in' aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            <div className="table-responsive">
                                <table className="mycart-table" width="100%">
                                    <tbody>
                                        {(quoteList && Object.entries(quoteList).length > 0) &&
                                            Object.entries(quoteList).map((v, i) => (
                                                <tr key={i}>
                                                    <td className="acc-product-img">
                                                        <div className="product-info nopadding">
                                                            <span className='checkout-item-count'>Item: {i + 1}</span>
                                                            <div className="product-img sect-1 text-center">
                                                                <img src={v[1].product && v[1].product.AssetURL !== undefined && v[1].product.AssetURL !== null && v[1].product.AssetURL.trim() !== '' ? v[1].product.AssetURL : noImage} alt='Product' />
                                                            </div>
                                                            <div className="prod-option-icon sect-2 d-flex flex-wrap">
                                                                <div className="d-flex justify-content-between">
                                                                    <ProductLegends
                                                                        single_product={v[1].product}
                                                                        onlyIcon={true} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="acc-product-name">
                                                        <div className="d-flex ">
                                                            <div className="product-detail">
                                                                <div className="product-name">
                                                                    <strong>{v[1].ERPMFRPartNumber}</strong>
                                                                    <br />
                                                                    <span>by</span> {v[1]?.product?.ManufacturerName}
                                                                    <br />
                                                                    {v[1].customerPartNumber && <strong>{v[1].customerPartNumber}</strong>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="acc-product-info">
                                                        <div className={v.backOrderedQuantity > 0 ? "bs5 row" : "bs5 row d-none"}>
                                                            <div className="col-8">Backordered:</div>
                                                            <div className="col-4 text-end">{v.backOrderedQuantity}</div>
                                                        </div>
                                                        <div className="bs5 row">
                                                        </div>
                                                    </td>
                                                    <td className="acc-product-total">
                                                        <div className="bs5 row">
                                                            <div className="col-4">Unit Price:</div>
                                                            <div className="col-8 text-end text-right">
                                                                {Helper.getFormatNumber(Number(v[1][`quotedPrice_${v[1].quantity_field_selected}`]), quoteCurrency, getSymbolFromCurrency(quoteCurrency), 5)}
                                                            </div>
                                                        </div>
                                                        <div className="bs5 row">
                                                            <div className="col-4">Subtotal:</div>
                                                            <div className="col-8 text-end">
                                                                {Helper.getFormatNumber(Number(v[1][`subTotal_${v[1].quantity_field_selected}`]), quoteCurrency, getSymbolFromCurrency(quoteCurrency))}
                                                            </div>
                                                        </div>
                                                        <div className="bs5 row">
                                                            <div className="col-4">Quantity:</div>
                                                            <div className="col-8 text-end  text-right">
                                                                {v[1][`quantity_${v[1].quantity_field_selected}`]}
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default QuoteCheckoutMyCart;